/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SEND_REMINDER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.payoutDetail.send.reminder',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SEND_REMINDER' },
      },
    },
    SEND_REMINDER: {
      invoke: {
        id: 'sendReminder',
        src: 'sendReminder',
        onDone: {
          target: 'SEND_REMINDER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SEND_REMINDER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SEND_REMINDER_SUCCESS: {
      on: {
        START: { target: 'SEND_REMINDER' },
      },
    },
    SEND_REMINDER_FAILED: {
      on: {
        START: { target: 'SEND_REMINDER' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
